import { css } from '@emotion/react';
import { applyFont, tokens } from '@domain-group/fe-brary';

const { colors, spacing, typography } = tokens;

export const measure = css`
  font-family: inherit;
  position: fixed;
  top: -9999px;
  left: -9999px;
  visibility: hidden;
  white-space: normal;
  word-break: break-word;
  pointer-events: none;
  ${applyFont(typography.caption)}
`;

// Matches the rendered "Read more"/"Show less" button's font so the
// binary-search measurement doesn't underestimate its width.
export const measureSuffix = css`
  ${applyFont(typography.captionBold)}
  display: inline-block;
  white-space: nowrap;
`;

export const body = css`
  ${applyFont(typography.caption)}
  color: ${colors.neutral.medium.default};
  margin: 0;
`;

// Baseline shown before JS measurement has run (SSR/pre-hydration), so the
// initial paint already has the same height as the measured, truncated
// state and hydration doesn't cause a layout shift.
export const clampedBody = css`
  ${body}
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow: hidden;
`;

export const readMoreButton = css`
  ${applyFont(typography.captionBold)}
  background: none;
  border: 0;
  color: ${colors.neutral.heavy.default};
  cursor: pointer;
  padding: 0;
`;

export const showLessButton = css`
  ${readMoreButton}
  padding-left: ${spacing.xxs};
`;
